
const urlParams = {
    protocol:'https',
    ip:`${'miller-server.alliames.app.br'}`,
}
export default urlParams;








